import type { CalendarDto } from '../../api/calendar';
import { listTeamMembers } from '../../api/project-teams';

/**
 * 「[팀명] 팀원 모두 초대」의 «누구를 불러오나» — 캘린더 하나 → 구성원을 주는 곳 (2026-10-13 이식).
 *
 * 출처: 옛 가지 4b3338c66 · a881fa6a5 · 9b12617fe · AOS b7c844e7e(같은 규칙: 업무 메뉴가 없으면 숨긴다).
 *
 * ## ⭐ 왜 «함수 하나»로 갈라 두었나
 * 지금은 «프로젝트 팀» 캘린더(`teamId`)만 구성원을 준다(`GET /project-teams/:id/members`).
 * **조직도 팀(부서) 캘린더는 다른 판이 만든다** — 그 판은 이 함수에 갈래 «하나»만 더하면
 * 같은 단추(`TeamInviteButton`)를 그대로 쓴다(단추는 어디서 오는지 모른다).
 *
 * ## ⛔ 업무(task) 메뉴가 없으면 «없다»
 * 서버가 그 메뉴 권한 아래에서만 팀원을 준다(메뉴를 끈 회사는 404 MENU_DISABLED).
 * 누르면 실패할 단추를 보여 주지 않는다 — AOS `calTeamInviteTarget` 과 같은 판정이다.
 */
export interface InviteMember {
  id: string;
  name: string;
}

export interface CalendarInviteSource {
  /** 단추 글자에 들어갈 이름(「마케팅팀」). */
  teamName: string;
  /** 바뀌면 단추 상태(알림 줄)를 비운다. */
  key: string;
  load: () => Promise<InviteMember[]>;
}

export function inviteSourceForCalendar(
  cal: CalendarDto | null | undefined,
  opts: { taskMenuEnabled: boolean },
): CalendarInviteSource | null {
  if (!cal) return null;
  if (cal.teamId) {
    if (!opts.taskMenuEnabled) return null;
    const teamId = cal.teamId;
    return {
      teamName: cal.teamName || cal.name,
      key: `project-team:${teamId}`,
      load: async () => (await listTeamMembers(teamId))
        .filter((m) => !!m.userId)
        .map((m) => ({ id: String(m.userId), name: m.name || m.email || String(m.userId) })),
    };
  }
  // ⏸ 조직도 팀(부서) 캘린더 — 다른 판이 여기에 갈래를 더한다(머리말).
  return null;
}
